import { render, staticRenderFns } from "./AppointmentChooseAddressPage.vue?vue&type=template&id=38a8a87f"
import script from "./AppointmentChooseAddressPage.vue?vue&type=script&lang=ts"
export * from "./AppointmentChooseAddressPage.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentChooseAddressPage.vue?vue&type=style&index=0&id=38a8a87f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports